import 'react-instantsearch-theme-algolia/style.scss';
import './style/index.scss';

import App from './components/app';

export default App;



// WEBPACK FOOTER //
// ./index.js